import { DateSelectionModelChange } from "@angular/material/datepicker"
import { ClassOffering } from "./class-offering.model"
import { CourseInstructorDTO } from "./course-instructor-dto.model"
import { RecordOfCompletionDTO } from "./record-of-completion.model"

export class TPWorker {
  FirstName: string
  LastName: string
  EmailAddress: string
  PhoneNumber: string
  SecondaryEmailAddress?: string
  SecondaryPhoneNumber?: string
  Address: string
  City: string
  PostalCode: string
  CompletionConsent: boolean
  FeedbackConsent: boolean
  ResearchConsent: boolean
  WahInfoConsent: boolean
  JhscInfoConsent: boolean
  Id: string
  isSelected?: boolean
  WorkerDisplayId?: string
  PreviousWorkerDisplayId?: string
  MergedOn?: Date
  MergedBy?: string
  LastUpdateDate?: Date
  EnrolmentLastUpdateDate?: Date
  TrainingHistory?: WorkerTrainingHistory[]
  RecordsOfCompletion?: RecordOfCompletionDTO[]
  Expanded?: boolean
  TotalPrograms?: number
  TopProgram?: string
  BirthYear?: Date | number
  Country?: string
  Province?: string
  AddressLine?: string
  AptSuiteUnit?: string
  TotalQueryResultCount?: number
  CreatedDate?: Date
  LastLogin?: Date
  PoBox?: string
  PersonId?: string
  IsDisabled?: boolean
}

export class WorkerTrainingHistory {
  TrainingProgramId: string;
  TrainingProviderName: string;
  ProviderId: string;
  WorkerId: string;
  RegistrationId: string;
  WorkerDisplayId: string;
  ProgramFullName: string;
  ProgramFullNameFr: string;
  DeliveryType: string;
  CertificationCode: string
  ProgramId: string;
  TrainingLocation?: string;
  Classes: ClassOffering[];
  CourseInstructors: CourseInstructorDTO[];
  CompletionDate: Date;
  HasCompleted?: boolean;
  expand?: boolean
  CourseId?: string;
  ExpirationDate?: Date;
  RecordOfCompletion?: RecordOfCompletionDTO;
  DeliveryLanguage?: string
  IsExemption?: boolean;
  IsExtension?: boolean;
  DecisionStatusId?: number;
}

export class LearnerCertificateStatus {
  Learner?: TPWorker;
  RecordOfCompletion?: RecordOfCompletionDTO;
}
